import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom'
import { TreatmentTemplate, fetchTreatmentTemplate } from '../../api/treatments'
import { Panel, PanelBody, PanelHeading } from '../../components/common'

function PreservedText({ text }: { text: string | null }) {
  return <p style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
}

export function loader({ params }: LoaderFunctionArgs): Promise<TreatmentTemplate> {
  return fetchTreatmentTemplate(Number(params.healthCenterId), params.templateId as string)
}

export default function TreatmentTemplateShowPage() {
  const template = useLoaderData() as Awaited<ReturnType<typeof loader>>

  return (
    <Panel>
      <PanelHeading>
        <h1>Tratamiento {template.name}</h1>
      </PanelHeading>
      <PanelBody className="container">
        <p>
          <strong>Nombre:</strong> {template.name}
        </p>
        <p>
          <strong>Código:</strong> {template.code}
        </p>
        <p>
          <strong>Precio:</strong> {template.price}
        </p>
        <p>
          <strong>Descripción:</strong>
        </p>
        <PreservedText text={template.description} />
        <p>
          <strong>Nota:</strong>
        </p>
        <PreservedText text={template.note} />
      </PanelBody>
    </Panel>
  )
}
